import { render, staticRenderFns } from "./QASettinghtml.vue?vue&type=template&id=8adfc5ec&scoped=true&"
import script from "./QASettinghtml.vue?vue&type=script&lang=js&"
export * from "./QASettinghtml.vue?vue&type=script&lang=js&"
import style0 from "./QASettinghtml.vue?vue&type=style&index=0&id=8adfc5ec&prod&lang=scss&"
import style1 from "./QASettinghtml.vue?vue&type=style&index=1&id=8adfc5ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8adfc5ec",
  null
  
)

export default component.exports